module.exports = __webpack_public_path__ + "static/media/Cash_Out.cc3d28e7.svg";